import React from "react";
import "./RecFishingStats.scss";
import utils from "../../../../helpers/utils";
import { RecFishingConfig } from "../RecFishingConfig";
import LargeStat from "../../../Stats/LargeStat";
import SmallStat from "../../../Stats/SmallStat";
import { Grid } from "@material-ui/core";

function RecFishingStats(props) {
  const { stats, selectedGeometry } = props;

  /**
   * Full stats are full width
   */
  const fullStats = RecFishingConfig.stats.large;

  /**
   * short stats are half width
   */
  const shortStats = RecFishingConfig.stats.small;

  const country = utils.getCountryAttrForSelectedGeometry(
    selectedGeometry
  );

  return (
    <div className="recFishingStats">
      {Object.keys(stats).length > 0 && (
        <>
          <Grid container className="short-stat-container">
            {shortStats.map((item) => (
              <SmallStat
                key={item.name}
                size={6}
                item={item}
                stats={stats}
                country={country}
              />
            ))}
          </Grid>
          <div className="large-stat-container">
            {fullStats.map((item) => (
              <LargeStat
                key={item.name}
                item={item}
                handleStatClick={null}
                selectedStat={null}
                stats={stats}
                country={country}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default RecFishingStats;
